export const CHANNEL_TOTAL_HEIGHT = 65;
export const CHANNEL_HEIGHT = 50;
export const CHANNEL_CATEGORY_TOTAL_HEIGHT = 40;
export const CHANNEL_CATEGORY_HEIGHT = 35;
export const CHANNEL_CATEGORY_TIME_MARKER_HEIGHT = 38;
export const CHANNEL_LIST_LEFT = 0;
export const TIME_LABEL_WIDTH = 255;
export const LEFT_PANEL_WIDTH = 210;
export const TIME_LIST_HEIGHT = 41;
export const TIMEMARK_WIDTH = 420;
export const CHANNEL_GUTTER = 4;
export const HEADER_HEIGHT = 54;
export const HEADER_FULLSCREEN_HEIGHT = 64;
export const FOOTER_HEIGHT_MOBILE = 50;
export const CHAT_TAB_HEIGHT = 48;

export const DESKTOP_CHAT_BAR_WIDTH = '30vw';
export const DESKTOP_GUIDE_WIDTH = '70vw';
export const CHAT_WIDTH = '30vw';

export const DEFAULT_CHANNEL_NUMBER = 51; // first channel to show on load
export const CHANNEL_LIST_SIZE = 11; // how many channels should the guide show (max, when expanded)

// We do not have yet a way to know what channel is the 'Winner + Movie' one (no field is send by
// the API to mark it). So use its slug to identify.
export const WAM_SLUG = 'winner-and-a-movie';
// Naming convention: any Winner and a Movie content will have the following pattern
// "EPISODE_NAME (Winner and a Movie Edition)"
export const WAM_EPISODE_TITLE = 'Winner and a Movie';

// Naming convention: any ChatLive content will have the following pattern
// "EPISODE_DESCRIPTION Chat Live"
export const CHAT_EPISODE_TITLE = 'Chat Live';

export const ALLOW_CHAT_X_MINS_BEFORE = 10;
export const ALLOW_CHAT_X_MINS_AFTER = 10;
